import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { STORAGE_SERVICE_KEYS, StorageService } from '../core/storage.service';
import { IExchangeCar } from './exchange-car.models';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ExchangeCarService {
    private exchangeCarsSubject$ = new BehaviorSubject<IExchangeCar[]>([]);
    get exchangeCars() {
        return this.exchangeCarsSubject$.asObservable();
    }

    constructor(private storageService: StorageService) {
        this.exchangeCarsSubject$.next(this.getListFromStorage());
        this.exchangeCarsSubject$.pipe(tap((list) => this.setListInStorage(list))).subscribe();
    }

    addExchangeCar(data: IExchangeCar) {
        this.exchangeCarsSubject$.next([...this.exchangeCarsSubject$.value, { ...data, id: `${data.model?.summary}${Date.now()}` }]);
    }

    removedExchangeCar(id: string) {
        this.exchangeCarsSubject$.next([...this.exchangeCarsSubject$.value.filter((exc) => exc.id !== id)]);
    }

    private getListFromStorage() {
        const list = this.storageService.getItem(STORAGE_SERVICE_KEYS.USER_EXCHANGE_CAR_LIST, true);
        return list ? JSON.parse(list) : [];
    }

    private setListInStorage(list: IExchangeCar[]) {
        this.storageService.setItem(STORAGE_SERVICE_KEYS.USER_EXCHANGE_CAR_LIST, JSON.stringify(list), true);
    }
}
